import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Redirect } from 'react-router';

import { useRouter } from '../../hooks';
import { paths } from '../../paths';
import { AuthContext } from '../../store/Auth';
import NewsletterBlock from '../../containers/NewsletterBlock';
import FormLayout from '../../components/Layout/Form/FormLayout';

import './styles.scss';

const NewsletterPage = () => {
  const { generatePath } = useRouter();
  const { isAuthenticated } = useContext(AuthContext);
  const { t } = useTranslation();

  if (isAuthenticated) {
    return <Redirect to={generatePath(paths.ACCOUNT_INFORMATION)} />;
  }

  return (
    <FormLayout title={t('newsletter-page.title')} subtitle={t('newsletter-page.subtitle')} className="newsletter-page">
      <NewsletterBlock newsletterPage={true} />
    </FormLayout>
  );
};

export default NewsletterPage;
